export default __webpack_public_path__ + "static/media/feeder.388673c4.png";